import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Home from '../pages/Home/index.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/auth/website',
        alias: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/auth/website/doc',
        alias: '/doc',
        name: 'Document',
        component: () => import(/* webpackChunkName: "Document" */ '../pages/Doc/index.vue')
    },
    {
        path: '/auth/website/demo',
        alias: '/demo',
        name: 'Demo',
        component: () => import(/* webpackChunkName: "Demo" */ '../pages/Demo/index.vue')
    },
    {
        alias: '/model',
        path: '/auth/website/model',
        name: 'Model',
        component: () => import(/* webpackChunkName: "Model" */ '../pages/Model/index.vue')
    },
    {
        alias: '/mobilenet',
        path: '/auth/website/mobilenet',
        name: 'Mobilenet',
        component: () => import(/* webpackChunkName: "Mobilenet" */ '../pages/Demo/Mobilenet/index.vue')
    },
    {
        alias: '/wine',
        path: '/auth/website/wine',
        name: 'Wine',
        component: () => import(/* webpackChunkName: "Wine" */ '../pages/Demo/Wine/index.vue')
    },
    {
        alias: '/humanStream',
        path: '/auth/website/humanStream',
        name: 'HumanStream',
        component: () => import(/* webpackChunkName: "HumanStream" */ '../pages/Demo/HumanStream/index.vue')
    },
    {
        alias: '/humanseg',
        path: '/auth/website/humanseg',
        name: 'HumanSeg',
        component: () => import(/* webpackChunkName: "HumanSeg" */ '../pages/Demo/HumanSeg/index.vue')
    },
    {
        alias: '/gesture',
        path: '/auth/website/gesture',
        name: 'Gesture',
        component: () => import(/* webpackChunkName: "Gesture" */ '../pages/Demo/Gesture/index.vue')
    },
    {
        alias: '/ocrdet',
        path: '/auth/website/ocrdet',
        name: 'OcrDet',
        component: () => import(/* webpackChunkName: "OcrDet" */ '../pages/Demo/OcrDet/index.vue')
    },
    {
        alias: '/ocr',
        path: '/auth/website/ocr',
        name: 'Ocr',
        component: () => import(/* webpackChunkName: "Ocr" */ '../pages/Demo/Ocr/index.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.afterEach(() => {
    window.scrollTo(0, 0);
})

export default router
